const DEFAULT_TEST_CENTER_ID = '00000';

export default DEFAULT_TEST_CENTER_ID;
